import { useMemo } from 'react';
import { Navigate } from 'react-router';
import { PageConferenceEnded, PageMobileRichTextEditor, PagePrivacyPolicy, PageUnsubscribe } from 'pages';
import { routes } from '../../routes';
import type { RouterConfig } from '../Router';
import { usePlatformRouter } from './usePlatformRouter';

export const useAppRouter = (config: RouterConfig) => {
  const platformRouter = usePlatformRouter(config);

  return useMemo(
    () => [
      {
        element: <Navigate replace to={routes.privacyPolicy} />,
        path: '/privacy.html',
      },
      {
        element: <Navigate replace to={routes.privacyPolicy} />,
        path: '/privacy-myowndoctor.html',
      },
      {
        element: <PageMobileRichTextEditor />,
        path: '/mobile-app/rich-text-editor',
      },
      {
        element: <PageUnsubscribe />,
        path: '/email-unsubscribe',
      },
      {
        element: <PageConferenceEnded />,
        path: '/conference-ended',
      },
      {
        element: <PagePrivacyPolicy />,
        path: routes.privacyPolicy,
      },
      ...platformRouter,
    ],
    [platformRouter],
  );
};
